import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Tabs,
  Tab,
  Box,
  Typography,
  Fade,
  Button,
  Paper,
  Grid,
  IconButton,
  Chip,
  Alert,
  CircularProgress,
  Avatar,
  Slide,
  Tooltip as MuiTooltip,
} from '@mui/material';
import UseToast from '../../UseToast';
import WayfinderCard from '../WayfinderCard';
import useS3Upload from '../../../hooks/useS3Upload';
import LocationManagerCard from '../LocationManagerCard';
import { getLanguageText } from '../../../utils/multilanguageUtils';

export const MainLocationTab = ({ currentLanguage = 'en' }) => {
  const [buttonColor, setButtonColor] = useState('#000000');
  const { showMsgSuccessToast, showErrorToast } = UseToast();
  const { id, userId } = useParams();
  const navigate = useNavigate();
  const isEffectRan = useRef(false);
  const [isLoading, setIsLoading] = useState(false);

  const fetchBrandColor = async () => {
    try {
      if (userId) {
        const res = await axios.get(`/auth/aiform/all/${userId}`);

        const data = res.data?.UserData?.brandColor;
        setButtonColor(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const createFrontItem = async (frontState, api, setFrontState, fetchFunction, type) => {
    if (!frontState.trim()) return;
    axios
      .post(`/api/wayfinder/${api}`, {
        name: frontState,
        userId: userId,
      })
      .then(response => {
        if (!response.data.error) {
          fetchFunction();
          setFrontState('');
          showMsgSuccessToast(`${type} created successfully!`);
        } else {
          showErrorToast(response.data?.msg);
        }
      });
  };

  const goBack = () => {
    navigate(-1);
  };

  // Add these state variables for locations
  const [frontLocationName, setFrontLocationName] = useState('');
  const [locations, setLocations] = useState([]);
  const [allLocations, setAllLocations] = useState([]);

  const fetchLocations = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`/api/wayfinder/get-locations/${userId}`);
      console.log('Locations response:', response);
      if (response.data.success) {
        setLocations(response.data.data || []);
        setAllLocations(response.data.data || []);
      }
    } catch (error) {
      console.error('Error fetching locations:', error);
      showErrorToast('Failed to load locations');
    } finally {
      setIsLoading(false);
    }
  };

  const toggleLocationVisibility = (locationId, isVisible) => {
    axios
      .patch(`/api/wayfinder/locations/${locationId}/status`, {
        status: !isVisible,
        userId: userId,
      })
      .then(response => {
        if (response.data.success) {
          setLocations(prev =>
            prev.map(loc => (loc._id === locationId ? { ...loc, status: !isVisible } : loc))
          );
          showMsgSuccessToast(`Location ${!isVisible ? 'activated' : 'deactivated'} successfully!`);
        }
      })
      .catch(error => {
        console.error('Error toggling location:', error);
        showErrorToast('Failed to update location visibility');
      });
  };

  const deleteLocation = locationId => {
    // if (!window.confirm('Are you sure you want to delete this location?')) return;

    axios
      .delete(`/api/wayfinder/delete-wayfinder-location/${locationId}`, {
        data: { userId },
      })
      .then(response => {
        if (response.data.success) {
          setLocations(prev => prev.filter(loc => loc._id !== locationId));
          showMsgSuccessToast('Location deleted successfully!');
        } else {
          showErrorToast(response.data.message);
        }
      })
      .catch(error => {
        console.error('Error deleting location:', error);
        showErrorToast('Failed to delete location');
      });
  };

  useEffect(() => {
    if (userId && !isEffectRan.current) {
      isEffectRan.current = true;
      fetchBrandColor();
      fetchLocations();
    }
  }, [userId]);

  return (
    <>
      <Box sx={{ bgcolor: 'background.paper' }}>
        {isLoading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
            <CircularProgress sx={{ color: buttonColor }} />
          </Box>
        ) : (
          <>
            <Box sx={{ minHeight: '100vh', width: '100%' }}>
              <Grid container spacing={3} justifyContent="center">
                <Grid
                  item
                  xs={12}
                  lg={8}
                  style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                >
                  <div
                    className="menu-card"
                    style={{
                      padding: '20px',
                      marginBottom: '20px',
                      minWidth: '600px',
                    }}
                  >
                    {/* OLD LOCATION CARD - COMMENTED OUT */}
                    {/* <div className="menu-title">
                      <span>{'Locations'}</span>
                    </div>

                    <WayfinderCard
                      items={locations}
                      userId={userId}
                      buttonColor={buttonColor}
                      placeholder="Enter new location name"
                      inputValue={frontLocationName}
                      onInputChange={e => setFrontLocationName(e.target.value)}
                      onSubmit={() =>
                        createFrontItem(
                          frontLocationName,
                          'locations',
                          setFrontLocationName,
                          fetchLocations,
                          'Location'
                        )
                      }
                      handleToggleVisibility={toggleLocationVisibility}
                      onDelete={id => deleteLocation(id, true)}
                      type="locations"
                      submitButtonText="+"
                    />

                    <hr style={{ margin: '30px 0', border: 'none', borderTop: '2px solid #e0e0e0' }} /> */}

                    {/* Location Manager - Grouped by Categories/Subcategories */}
                    <div className="menu-title" style={{ marginBottom: '15px' }}>
                      <span>{'Location Manager'}</span>
                    </div>

                    <LocationManagerCard
                      userId={userId}
                      buttonColor={buttonColor}
                      showMsgSuccessToast={showMsgSuccessToast}
                      showErrorToast={showErrorToast}
                      currentLanguage={currentLanguage}
                    />
                  </div>
                </Grid>
              </Grid>
            </Box>
          </>
        )}
      </Box>
    </>
  );
};
